<template>
    <modal v-if="show">
        <h2 slot="header">How to post a video on Pimblr</h2>
        <div slot="body">
            <video src="https://vt.media.tumblr.com/tumblr_p6vjjx16b51x770v3.mp4" controls></video>
        </div>
        <div slot="footer">
            <button class="btn btn-xs btn-primary" @click="show=false">Got it!</button>
        </div>
    </modal>
</template>

<script>
    import Modal from "../ui/Modal";
    export default {
        name: "HowToPostVideo",
        components: {Modal},
        data(){
            return {
                show: false
            }
        },
        mounted(){
            this.$bus.$on('ShowHowToPostVideo', ()=>{
                this.show = true;
            });
            this.$bus.$on('closeModal', ()=>{
                this.show = false;
            });
        }
    }
</script>

<style lang="sass" scoped>
    video
        max-width: 100%
        height: auto
</style>


// WEBPACK FOOTER //
// src/components/content/HowToPostVideo.vue